import { FeedbackPopup } from '../popup/feedback-popup/feedback-popup';

export default new class FeedbackList {
    constructor() {
        this.page = '.fs-feedback-list-page';

        if (!document.querySelector(this.page)) return;

        this.btnAdd = '.fs-feedback--create-btn';
        this.FeedbackPopup = new FeedbackPopup();

        this.eventsHandler();
    }

    eventsHandler() {
        document.querySelector(this.btnAdd).addEventListener(this.handleBtnAddClick)
    }

    handleBtnAddClick = () => {
        this.FeedbackPopup.open();
    }
}